// src/pages/Departments/Index.js
import { Link } from "react-router-dom";

export default function Departments() {
  const list = [
    { name: "आस्थापना विभाग", link: "aashtapna" },
    { name: "लेखा विभाग", link: "lekha" },
    { name: "पंचायत विभाग", link: "panchayat" },
    { name: "बांधकाम विभाग", link: "bandhkam" },
    { name: "शिक्षण विभाग", link: "shikshan" },
    { name: "कृषी विभाग", link: "krishi" },
    { name: "महिला व बालकल्याण", link: "mahila-bal" },
    
    { name: "म.रा.रो.हमी योजना", link: "srj-abhiyan" },
    { name: "पशुसंवर्धन विभाग", link: "pashu" },
    { name: "स्वच्छ भारत मिशन", link: "sbm" },
  ];

  const styles = {
    page: {
      padding: "30px 20px",
      maxWidth: "1100px",
      margin: "0 auto",
      fontFamily: "'Noto Sans Devanagari', sans-serif",
      color: "#222",
    },
    headerBox: {
      textAlign: "center",
      marginBottom: "22px",
    },
    title: {
      fontSize: "28px",
      fontWeight: 800,
      color: "#2E2B5F",
      marginBottom: "6px",
    },
    subtitle: {
      fontSize: "14px",
      color: "#555",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "18px",
      marginTop: "20px",
    },
    card: {
      background: "linear-gradient(180deg, #ffffff 0%, #f7f8ff 100%)",
      borderRadius: "12px",
      padding: "18px",
      boxShadow: "0 6px 18px rgba(46,43,95,0.12)",
      transition: "transform 200ms ease, box-shadow 200ms ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      border: "1px solid rgba(46,43,95,0.04)",
    },
    cardHover: {
      transform: "translateY(-6px)",
      boxShadow: "0 12px 30px rgba(46,43,95,0.16)",
    },
    deptName: {
      fontSize: "16px",
      fontWeight: 700,
      color: "#2E2B5F",
      textDecoration: "none",
    },
    arrow: {
      background: "#4A148C",
      color: "white",
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: 700,
      textDecoration: "none",
    },
    listFallback: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.headerBox}>
        <h2 style={styles.title}>विभाग</h2>
        <div style={styles.subtitle}>खालील विभागांपैकी कोणत्याही वर क्लिक करा — विभागाची पूर्ण माहिती मिळेल.</div>
      </div>

      <div style={styles.grid}>
        {list.map((d, i) => (
          <Link
            key={i}
            to={`/departments/${d.link}`}
            style={{ ...styles.card, textDecoration: "none" }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-6px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0)")
            }
          >
            <div style={styles.deptName}>{d.name}</div>
            <div style={styles.arrow}>घ्या →</div>
          </Link>
        ))}
      </div>

      {/* If you prefer an ordered list fallback */}
      {/* <ul style={styles.listFallback}>
        {list.map((d, i) => (
          <li key={i}><Link to={`/departments/${d.link}`}>{d.name}</Link></li>
        ))}
      </ul> */}
    </div>
  );
}
